import { z } from "zod";
import {
	optionalFilterString,
	optionalFilterStringArray,
} from "@/schemas/filter.schema";
import { IssueStatus } from "@/types/issues.types";

const DEFAULT_CLEANING_STATUSES = [
	IssueStatus.DRAFT,
	IssueStatus.CREATED,
	IssueStatus.IN_PROGRESS,
	IssueStatus.BLOCKED,
].join(",");

export const cleaningsFilterSchema = z.object({
	search: optionalFilterString,
	types: optionalFilterString,
	urgencies: optionalFilterString,
	statuses: optionalFilterString.default(DEFAULT_CLEANING_STATUSES),
	deadlinePeriod: optionalFilterString,
	vehicleIds: optionalFilterStringArray,
});

/** Output type - statuses has default applied */
export type CleaningsFilter = z.output<typeof cleaningsFilterSchema>;

/** Input type - for service parameters where statuses is optional */
export type CleaningsFilterInput = z.input<typeof cleaningsFilterSchema>;
